define(['jquery', 'masonry', 'imagesLoaded'], function ($, Masonry, imagesLoaded) {

    //Mobile navigation
    var $body = $('body'),
        $navToggle = $('.nav-toggle'),
        bodyHeight;

    //Event Handler - Clicking the hamburger in mobile will display the mobile navigation
    $navToggle.on("click tap", function () {

        //navToggle
        var $this = $(this);

        //Check to determine if the mobile menu is opened
        if (!$this.hasClass('js-is-active')) {

            $this.addClass('js-is-active');

            bodyHeight = window.innerHeight;
            //add class to the body to fire off css animation and have teh body move off canvas and bring in the mobile menu
            //Compute the height of the viewport to prevent the user from scrolling off canvas
            $body.addClass('js-nav-active').css('height', bodyHeight);
        }

        else {
            $this.removeClass('js-is-active');
            $body.removeClass('js-nav-active').css('height', 'auto');
        }
    });

    //not sure why this is here
    //$("#recaptcha_response_field").

    //Masonry, capabilities detail, Insights landing, page

    var container = document.querySelector('.site-main.site-main--interior');

    if (!!container) {

        imagesLoaded(container, function () {
            $(".masonry-board").each(function () {
                var secondContainer = $(this).get(0);

                if (!!secondContainer) {
                    var msnry = new Masonry(secondContainer, {
                        "gutter": secondContainer.querySelector('.gutter-sizer'),
                        "itemSelector": '.box',
                        "columnWidth": secondContainer.querySelector('.grid-sizer'),
                    });
                }
            })

        });

    };


    //professional resulting listing. this bit of code will add a break after the ampersands
    //to email addresses that wrap

    var $allEmails = $('.professional-results').find('.read-more');
    var profWidth = $('.professional-results').find('.media-body ').eq(0).width();

    var $wrappedEmails = $allEmails.filter(function () {
        var elWidth = $(this).width();

        return elWidth > profWidth;
    });

    $wrappedEmails.each(function () {
        var newText = this.innerHTML.replace('@', '<br/>@');

        this.innerHTML = newText;

    });


    //contact us form, adding asterik to the end of the form
    var $contactForm = $('.contactus-form');

    if ($contactForm.hasClass('contactus-form')) {

        var $requiredFields = $contactForm.find('.required input'),
            placeholderText;

        $requiredFields.each(function () {
            $self = $(this);

            placeholderText = $self.attr('placeholder') + '*';
            $self.attr('placeholder', placeholderText);

        });
    }
    
    $('.js-back-btn').on('click', function () {
        history.back();                
    });
});